import { PayInReportGenerator } from './payInReportGenerator';
export { BasePDFGenerator } from '../reportUtils/base';
export type { PDFGeneratorConfig } from '../reportUtils/base';
export { PayInReportGenerator } from './payInReportGenerator';
export * from '../reportUtils/documentUtils';

export const generatePayInReportPDF = async (
  payIn: any,
  documents: any[],
  fncConciliations: any[],
  userName: string,
  imageBase64: string,
) => {
  const generator = new PayInReportGenerator({
    userName,
    imageBase64,
    title: 'Detalle Conciliaciones Pago',
    fileName: `REPORTE-CONCILIACIONES-PAGO-${payIn.businessOriginName}.pdf`,
    payIn,
    documents,
    fncConciliations,
  });
  await generator.generate();
};